import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {filter, switchMap, take} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private auth: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has('authorization')) {
      return next.handle(request);
    }

    return this.auth.userReady$.pipe(
      filter(ready => ready),
      take(1),
      switchMap(() => {
        const user = this.auth.getCurrentUser();
        return next.handle(request.clone({
          setHeaders: {
            authentication: (user.auth_token || ''),
            email: (user.email || ''),
            unlock: (user.unlock || '')
          }
        }));
      })
    );
  }
}
